import { styled } from '@linaria/react';
import { ReactNode } from 'react';

type Props = {
  content: ReactNode;
  backgroundColor?: string;
};

export const MainSection = ({ content, backgroundColor = 'var(--base-white)' }: Props) => {
  const isTransparent = backgroundColor === 'transparent';
  return (
    <Container isTransparent={isTransparent} style={{ backgroundColor }}>
      <Content>{content}</Content>
    </Container>
  );
};

const Container = styled.div<{ isTransparent: boolean }>`
  box-sizing: border-box;
  padding: ${({ isTransparent }) => (isTransparent ? 0 : '16px 24px')};
  flex: 1;
  min-height: 0;
  height: 100%;
  border-radius: 8px;
  overflow: hidden;
`;

const Content = styled.div`
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;

  /* Hide scrollbar for Chrome, Safari and Opera */
  &::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
`;
